import { useDevice } from '@/hooks/use-device';
import { ControlPosition, MapControl, useMap } from '@vis.gl/react-google-maps';
import classes from './zoom-control.module.css';

export function ZoomControl({ position = ControlPosition.RIGHT_BOTTOM }) {
  const map = useMap();
  const { isMobile } = useDevice();

  const zoomIn = () => {
    map?.setZoom((map.getZoom() ?? 0) + 1);
  };

  const zoomOut = () => {
    map?.setZoom(Math.max(0, (map.getZoom() ?? 0) - 1));
  };

  return (
    !isMobile && (
      <MapControl position={position}>
        <div className={classes.control}>
          <button type="button" className={classes.mapBtn} onClick={zoomIn} aria-label="Zoom in">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                d="M8.75 7.43359V1.18359C8.75 0.984681 8.67098 0.793916 8.53033 0.653264C8.38968 0.512611 8.19891
                0.433594 8 0.433594C7.80109 0.433594 7.61032 0.512611 7.46967 0.653264C7.32902 0.793916 7.25 0.984681
                7.25 1.18359V7.43359H1C0.801088 7.43359 0.610322 7.51261 0.46967 7.65326C0.329018 7.79392 0.25 7.98468
                0.25 8.18359C0.25 8.38251 0.329018 8.57327 0.46967 8.71392C0.610322 8.85458 0.801088 8.93359
                1 8.93359H7.25V15.1836C7.25259 15.3817 7.33244 15.571 7.47253 15.7111C7.61263 15.8512 7.80189 15.931
                8 15.9336C8.19891 15.9336 8.38968 15.8546 8.53033 15.7139C8.67098 15.5733 8.75 15.3825 8.75
                15.1836V8.93359H15C15.1989 8.93359 15.3897 8.85458 15.5303 8.71392C15.671 8.57327 15.75 8.38251
                15.75 8.18359C15.7474 7.98549 15.6676 7.79622 15.5275 7.65613C15.3874 7.51603 15.1981 7.43618
                15 7.43359H8.75Z"
              />
            </svg>
          </button>
          <button type="button" className={classes.mapBtn} onClick={zoomOut} aria-label="Zoom out">
            <svg width="18" height="3" viewBox="0 0 18 3" fill="none">
              <path
                d="M17 2.18359H1C0.734784 2.18359 0.48043 2.07824 0.292893 1.8907C0.105357 1.70316 0 1.44881 0 1.18359C0
                0.918377 0.105357 0.664024 0.292893 0.476487C0.48043 0.288951 0.734784 0.183594 1 0.183594H17C17.2652
                0.183594 17.5196 0.288951 17.7071 0.476487C17.8946 0.664024 18 0.918377 18 1.18359C18 1.44881 17.8946
                1.70316 17.7071 1.8907C17.5196 2.07824 17.2652 2.18359 17 2.18359Z"
              />
            </svg>
          </button>
        </div>
      </MapControl>
    )
  );
}
